<template>
  <div class="p-announcement">
    <NuxtLink class="p-announcement__link" :to="link">
      <div v-if="icon && $device.isDesktop" class="p-announcement__icon mt-32 mr-24">
        <NuxtImg :src="icon" :alt="heading" />
      </div>
      <div class="p-announcement__card">
        <div class="p-announcement__card--head">
          <NuxtLink v-if="category" :to="categoryLink" class="p-announcement__card--head__category">
            {{ category }}
          </NuxtLink>
          <p-divider v-if="category" :vertical="true" class="mx-12 py-8" />
          <div v-if="formattedDate" class="p-announcement__card--head__date">
            {{ formattedDate }}
          </div>
          <p-divider v-if="formattedDate && readingTime" :vertical="true" class="mx-12 py-8" />
          <div v-if="readingTime" class="p-announcement__card--head__reading-time">
            {{ readingTime }} dk okuma
          </div>
        </div>
        <div class="p-announcement__card--body">
          <div class="p-announcement__card--body__heading my-8">
            {{ heading }}
          </div>
          <div class="p-announcement__card--body__content">
            <div v-html="content"></div>
          </div>
        </div>
        <p-divider v-if="divider" class="my-24" />
        <div v-else class="my-24"></div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  category: {
    type: String,
    required: true,
  },
  categoryLink: {
    type: String,
    required: true,
    default: '',
  },
  date: {
    type: String,
    default: '',
  },
  readingTime: {
    type: Number,
    default: 0,
  },
  heading: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
    default: '#',
  },
  divider: {
    type: Boolean,
    default: true,
  },
})

const formattedDate = computed(() => {
  if (!props.date) return ''
  try {
    // Use full month name in Turkish for list view (e.g., "9 Ekim 2025")
    return new Intl.DateTimeFormat('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date(props.date))
  } catch (e) {
    return ''
  }
})
</script>
